<template>
  <div class="nav">
    <v-toolbar color="primary" dark class="fixed-top">
      <div class="ml-4">
        <div @click="goTo('/home')">
          <v-img
            style="width: 75px; cursor: pointer"
            @click="goTo('/home')"
            src="/img/Bripl3.png"
          />
        </div>
      </div>
      <div style="margin-left: 100px">
        <v-btn class="menu-btn" @click="goTo('/Channelmasterlist')">
          Channel
        </v-btn>
        <v-btn class="menu-btn" @click="goTo('/Planmasterlist')"> Plan </v-btn>

        <v-btn class="menu-btn" @click="goTo('/report/registration')">
          Registration
        </v-btn>
        <v-btn class="menu-btn" @click="goTo('/report/activation')">
          Activation
        </v-btn>
        <v-btn class="menu-btn" @click="goTo('/report/renewal')">
          Renewal
        </v-btn>
        <v-btn class="menu-btn" @click="goTo('/report/payments')">
          Payments
        </v-btn>
        <v-btn class="menu-btn" @click="goTo('/report/service')">
          Service Requests
        </v-btn>
        <v-btn class="menu-btn" @click="goTo('/report/payment/quickpay')">
          Quickpay
        </v-btn>
        <v-btn class="menu-btn" @click="goTo('/Updateuserid')">
          Update UserID
        </v-btn>
        <v-btn class="menu-btn" @click="goTo('/Walletupdate')">
          Wallet Update
        </v-btn>
        <v-btn class="menu-btn" @click="goTo('/OSDMessage')">
          OSD Message
        </v-btn>
        <v-btn class="menu-btn" @click="goTo('/CancelRegistration')">
          CANCEL REGISTRATION
        </v-btn>
        <v-btn class="menu-btn" @click="goTo('/ReprocessPayment')">
          REPROCESS PAYMENT
        </v-btn>
      </div>
      <!-- <v-toolbar-title style="margin-right:50px;">
        <div>
          <span
            style="cursor: pointer; margin-left:25px;font-size: 20px;"
          >
            Welcome
          </span>
        </div>
      </v-toolbar-title> -->
      <v-btn icon class="mr-4">
        <v-icon>mdi-shield-account</v-icon>
      </v-btn>
      <v-btn class="menu-btn" @click="logOut">Logout</v-btn>
    </v-toolbar>
  </div>
</template>
<script>
export default {
  data: () => ({
    offset: true,
    ractive: false,
    active: false,
  }),
  methods: {
    signOut() {
      localStorage.clear();
      this.$router.push({
        name: "Login",
      });
    },
    goTo(path, params) {
      this.$router.push({
        path,
        params,
      });
    },
    formatName(name) {
      const nameVal = name.toLowerCase();
      const names = nameVal.split(" ");
      //   console.log('names : ', names[0].substring(0, 1));
      return names
        .map((n) => n.substring(0, 1).toUpperCase() + n.substring(1))
        .join(" ");
    },
    logOut() {
      localStorage.removeItem("in:admin");
      this.$router.push({
        name: "Login",
      });
    },
  },
};
</script>
<style>
.submenu {
  background-color: #eee !important;
}
.active-item {
  color: #111 !important;
}
div {
  font-family: "Nunito", sans-serif;
}
.menu-btn {
  background: transparent !important;
  box-shadow: none !important;
}
.v-application .primary {
  background-image: linear-gradient(
    225deg,
    #59065d 0%,
    #8d0b93 50%,
    #061d48 100%
  );
}
.fa {
  color: #59065d !important;
}
</style>
